<div class="min-h-full pb-28 bg-gray-50 overflow-y-auto w-full mx-auto font-prompt">
  <!-- 1. Header 라이ระดับสีพรีเมียมโค้งมน -->
  <div
    class="bg-gradient-to-b from-[#2e2f38] to-[#1a1b20] pb-24 pt-8 px-6 rounded-b-[2.5rem] relative z-10 text-white text-left shadow-md w-full h-[200px]">
    <!-- ปุ่มย้อนกลับ -->
    <div class="flex items-center justify-between mb-6">
      <button (click)="goback()"
        class="w-8 h-8 p-2 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 active:scale-90 transition-all outline-none">
        <img src="icons/arrow_back_white.svg" class="w-5 h-5" />
      </button>
      <span
        class="text-[10px] font-bold tracking-wider text-amber-400 bg-amber-500/10 px-3 py-1 rounded-full uppercase">
        {{ currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิก" : "Card Activation" }}
      </span>
    </div>

    <!-- ข้อมูลส่วนหัว -->
    <div class="space-y-1">
      <h1 class="text-lg font-bold leading-tight truncate">
        {{ CardInfo?.cardName || siteName || (currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิก" : "Member Card Activation")
        }}
      </h1>
      <p class="text-[10px] text-amber-400 font-bold">
        {{ currentLang === "TH" ? "การเปิดใช้งานบัตรสมาชิกรายเดือน" : "Monthly Pass Card Activation" }}
      </p>
    </div>
  </div>

  <!-- 2. แผ่นฟอร์มกรอกข้อมูลทับซ้อนส่วนหัว -->
  <div class="px-4 -mt-16 relative z-20 space-y-4 pb-6">

    <!-- CARD 1: ระยะเวลาใช้งาน -->
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
      <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
        <img src="icons/calendar_today_orange.svg" class="w-5 h-5" />
        <h2 class="text-sm font-bold text-gray-700">
          {{ currentLang === "TH" ? "ระยะเวลาใช้งาน" : "Validity Period" }}
        </h2>
      </div>

      <div class="grid grid-cols-2 gap-3">
        <!-- วันที่เริ่มต้น -->
        <div class="bg-gray-50/70 rounded-2xl p-3.5 border border-gray-100 space-y-1">
          <label class="text-[10px] font-bold text-gray-400 block">
            {{ currentLang === "TH" ? "วันที่เริ่มต้นใช้งาน" : "Start Date" }}
          </label>
          <div class="flex items-center gap-2">
            <img src="icons/date_range_slate.svg" class="w-4 h-4 text-amber-500" />
            <span class="text-sm font-bold text-gray-800">
              {{ startDate ? (startDate | date: 'dd/MM/yyyy') : '-' }}
            </span>
          </div>
        </div>

        <!-- วันที่สิ้นสุด -->
        <div class="bg-gray-50/70 rounded-2xl p-3.5 border border-gray-100 space-y-1">
          <label class="text-[10px] font-bold text-gray-400 block">
            {{ currentLang === "TH" ? "วันที่สิ้นสุดใช้งาน" : "End Date" }}
          </label>
          <div class="flex items-center gap-2">
            <img src="icons/date_range_slate.svg" class="w-4 h-4 text-amber-500" />
            <span class="text-sm font-bold text-gray-800">
              {{ endDate ? (endDate | date: 'dd/MM/yyyy') : '-' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- CARD 2: ข้อมูลบัตรจอดรถ (กรณี renew) -->
    <div *ngIf="renew" class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
      <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
        <img src="icons/credit_card_slate.svg" class="w-5 h-5" />
        <h2 class="text-sm font-bold text-gray-700">
          {{ currentLang === "TH" ? "ข้อมูลบัตรจอดรถ" : "Parking Card Info" }}
        </h2>
      </div>

      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLang === "TH" ? "หมายเลขบัตรจอดรถ" : "Parking Card Number" }}
        </label>
        <input [value]="CardInfo?.cardName || ''" readonly type="text"
          class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 font-bold outline-none"
          [placeholder]="currentLang === 'TH' ? '-' : '-'" />
      </div>
    </div>

    <!-- CARD 3: ข้อมูลผู้สมัคร -->
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
      <div class="flex items-center gap-2 pb-2 border-b border-gray-50">
        <img src="icons/person_orange.svg" class="w-5 h-5" />
        <h2 class="text-sm font-bold text-gray-700">
          {{ currentLang === "TH" ? "ข้อมูลผู้สมัคร" : "Applicant Information" }}
        </h2>
      </div>

      <div>
        <label class="block font-bold text-xs text-gray-600 mb-1.5">
          {{ currentLang === "TH" ? "ชื่อผู้สมัคร" : "Applicant Name" }}
          <span class="text-red-500 font-bold">*</span>
        </label>
        <input [(ngModel)]="customer_name" type="text"
          class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold"
          [placeholder]="currentLang === 'TH' ? 'กรุณากรอกชื่อผู้สมัคร' : 'Enter full name'" />
      </div>
    </div>

    <!-- CARD 4: ข้อมูลทะเบียนรถ -->
    <div class="bg-white rounded-[2rem] shadow-xl border border-gray-100/50 p-6 space-y-4">
      <div class="flex items-center justify-between pb-2 border-b border-gray-50">
        <div class="flex items-center gap-2">
          <img src="icons/directions_car_orange.svg" class="w-5 h-5" />
          <h2 class="text-sm font-bold text-gray-700">
            {{ currentLang === "TH" ? "ทะเบียนรถ" : "Vehicle Plate" }}
          </h2>
        </div>
        <span class="text-xs font-bold text-amber-500 bg-amber-500/10 px-2.5 py-1 rounded-full">
          {{ selectCarPlate.length }} / {{ vehicleLimit }}
        </span>
      </div>

      <!-- แถบค้นหาและเพิ่มทะเบียนรถ -->
      <div class="flex items-center gap-2">
        <div class="relative flex-1">
          <input type="text"
            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl pl-10 pr-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 font-bold"
            [placeholder]="currentLang === 'TH' ? 'ค้นหาทะเบียนรถ...' : 'Search car plate...'"
            (input)="filterCarPlate($event)" />
          <img src="icons/search_slate.svg" class="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2" />
        </div>
        <button [disabled]="renew" (click)="toggleModalVehiclePlate(); $event.preventDefault()"
          class="px-4 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold text-xs rounded-xl shadow-md active:scale-95 transition-all flex items-center gap-1 shrink-0"
          [ngClass]="{ 'opacity-50 cursor-not-allowed': renew }">
          <img src="icons/add_white.svg" class="w-4 h-4" />
          <span>{{ currentLang === "TH" ? "เพิ่ม" : "Add" }}</span>
        </button>
      </div>

      <!-- รายการทะเบียนรถให้เลือก -->
      <div
        class="overflow-y-auto max-h-[220px] rounded-2xl border border-gray-100 divide-y divide-gray-50 custom-scrollbar"
        [ngClass]="{ 'opacity-60 pointer-events-none': renew }">
        <div *ngFor="let i of carFilteredPlateList.length > 0 ? carFilteredPlateList : carPlateList"
          (click)="toggleSelect(i, $event)"
          class="flex justify-between items-center px-4 py-3 cursor-pointer transition-all hover:bg-amber-50/50"
          [ngClass]="{
            'bg-amber-50/80 border-amber-200': isSelected(i.plate_number) && !isDisableCheckbox,
            'bg-white': !isSelected(i.plate_number) && !isDisableCheckbox,
            'cursor-not-allowed bg-gray-50': !isSelected(i.plate_number) && isDisableCheckbox
          }">
          <div class="flex items-center gap-3">
            <div class="relative w-5 h-5 flex items-center justify-center">
              <input type="checkbox"
                class="appearance-none rounded-md h-5 w-5 border border-gray-300 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer"
                [checked]="isSelected(i.plate_number)" (click)="$event.stopPropagation()"
                (change)="toggleSelect(i, $event)" />
              <svg *ngIf="isSelected(i.plate_number)" class="w-3.5 h-3.5 text-white absolute pointer-events-none"
                viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <span class="text-sm font-bold text-gray-800">{{ i.plate_number }}</span>
          </div>
          <span *ngIf="i.province_name" class="text-xs text-gray-400 font-bold bg-gray-100 px-2 py-0.5 rounded-md">
            {{ i.province_name }}
          </span>
        </div>
        <div *ngIf="(carFilteredPlateList.length === 0 && carPlateList.length === 0)"
          class="p-6 text-center text-xs font-bold text-gray-400">
          {{ currentLang === "TH" ? "ยังไม่มีรายการทะเบียนรถ" : "No vehicle plates found" }}
        </div>
      </div>
    </div>
  </div>

  <!-- ปุ่มดำเนินการหลักด้านล่างแบบ Sticky -->
  <div class="fixed bottom-0 left-0 right-0 p-4 bg-white/80 backdrop-blur-md border-t border-gray-100 z-30">
    <button (click)="showModal_confirm = true"
      class="w-full py-3.5 bg-amber-400 hover:from-amber-500 hover:to-amber-600 text-white font-bold rounded-2xl shadow-lg shadow-amber-500/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2">
      <span class="text-sm font-bold">{{ currentLang === "TH" ? "เปิดใช้งานบัตรสมาชิก" : "Activate Member Card"
        }}</span>
    </button>
  </div>
</div>

<!-- Modal เพิ่มทะเบียนรถ -->
<div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
  *ngIf="showModalVehiclePlate">
  <div
    class="bg-white rounded-[2rem] shadow-2xl w-full max-w-md overflow-hidden animate-fade-in-up border border-gray-100/50">
    <!-- Modal Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-100">
      <h2 class="text-base font-bold text-gray-800">
        {{ currentLang === "TH" ? "กรอกป้ายหมายเลขทะเบียนรถ" : "Add Vehicle License Plate" }}
      </h2>
      <button (click)="toggleModalVehiclePlate()"
        class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-500 transition-all outline-none">
        <img src="icons/close_slate.svg" class="w-4 h-4" />
      </button>
    </div>

    <!-- Modal Content -->
    <div class="p-6 space-y-4">
      <!-- Input ทะเบียน -->
      <div>
        <label class="block text-xs font-bold text-gray-700 mb-1.5">
          <span class="text-red-500 font-bold">* </span>
          {{ currentLang === "TH" ? "ทะเบียน" : "Vehicle Plate" }}
        </label>
        <input [(ngModel)]="license" type="text" placeholder="กรอกหมายเลขทะเบียน"
          class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold placeholder:text-gray-300" />
        <span *ngIf="licenseError" class="text-xs text-red-500 font-bold mt-1 block">
          {{ licenseError }}
        </span>
      </div>

      <!-- Select จังหวัด (Custom Dropdown) -->
      <div>
        <label class="block text-xs font-bold text-gray-700 mb-1.5">
          <span class="text-red-500 font-bold">* </span>
          {{ currentLang === "TH" ? "จังหวัด" : "Province" }}
        </label>
        <div class="relative w-full">
          <input
            class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-3 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all font-bold cursor-pointer"
            type="text" placeholder="กรุณาเลือกจังหวัด" [value]="selectedProvince ? selectedProvince.label : ''"
            readonly (click)="isOpenSelectVehicleProvince = !isOpenSelectVehicleProvince" />
          <span class="absolute right-3.5 top-1/2 -translate-y-1/2 pointer-events-none">
            <img src="icons/expand_more_slate.svg" class="w-5 h-5" />
          </span>

          <div *ngIf="isOpenSelectVehicleProvince" (mousedown)="$event.preventDefault()"
            class="absolute left-0 right-0 mt-2 rounded-2xl shadow-xl bg-white border border-gray-100 p-2 space-y-1 max-h-60 overflow-y-auto z-50 custom-scrollbar">
            <input [(ngModel)]="searchTerm"
              class="block w-full px-3 py-2 text-xs font-bold text-gray-800 border border-gray-200 rounded-xl outline-none focus:border-amber-400"
              type="text" [placeholder]="currentLang === 'TH' ? 'ค้นหาจังหวัด...' : 'Find a province...'"
              autocomplete="off" />

            <!-- รายการ dropdown -->
            <div *ngFor="let province of filterProvinces()">
              <button (click)="selectProvince(province)"
                class="block w-full text-left px-3 py-2 text-xs font-bold text-gray-700 hover:bg-amber-50 hover:text-amber-600 rounded-xl transition-all">
                {{ province.value }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Action Button -->
    <div class="p-6 pt-0">
      <button
        class="w-full py-3 bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-white font-bold rounded-xl shadow-md active:scale-95 transition-all text-sm"
        (click)="submitModalVehiclePlate()" type="submit">
        {{ currentLang === "TH" ? "ยืนยัน" : "Confirm" }}
      </button>
    </div>
  </div>
</div>

<!-- Modal Loading Overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<!-- Modal Confirm Warn -->
<app-pss-warn *ngIf="showModal_confirm"
  [detail]="currentLang === 'TH' ? 'ยืนยันการบันทึกเปิดใช้งานบัตรสมาชิก' : 'Confirm to open member card?'"
  [isButtonConfirm]="true" [language]="currentLang" (submit)="onClickSaveActiveMemberCard()"
  (close)="showModal_confirm = false">
</app-pss-warn>